import { createContext } from "react";
import { DefaultcabinetInterface, cabinetInterface } from "../../cabinets/types";

export interface DoctorInterface {
  _id: any,
  cabinet: cabinetInterface,
  RegNo: string,
  fullName: string,
  password: string,
  yearOfBirth: string,
  placeOfBirth: string,
  sex: string,
  contact: { 
    phone: string,
    whatsapp: string,
    email: string,
  },
  nationality: {
    current: string,
    origin: string,
  }
  medecinType: any,
  inscriptionDate: string,
  speciality: string,
  avatar: string,
  status: {
    disappeared: boolean,
    note: string,
  },
  isOwner: boolean,
}

export const DefaultDoctorInterface: DoctorInterface =  {
  _id: "",
  cabinet: DefaultcabinetInterface,
  RegNo: "",
  fullName: "",
  password: "",
  yearOfBirth: "",
  placeOfBirth: "",
  sex: "",
  contact: { 
    phone: "",
    whatsapp: "",
    email: "",
  },
  nationality: {
    current: "",
    origin: "",
  },
  medecinType: "",
  inscriptionDate: "",
  speciality: "",
  avatar: "",
  status: {
    disappeared: false,
    note: "",
  },
  isOwner: false,
}

export interface ShowDoctorInterface {
  showSuccessMsg: boolean, setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddModal: boolean, setShowAddModal: (showAddModal: boolean) => void,
  showEditModal: boolean, setShowEditModal: (showEditModal: boolean) => void,
  showDeleteModal: boolean, setShowDeleteModal: (showDeleteModal: boolean) => void,
  showDisappearModal: boolean, setShowDisappearModal: (showDisappearModal: boolean) => void,
  selectedDoctor: DoctorInterface, setSelectedDoctor: (selectedDoctor: DoctorInterface) => void,
}

export const DefaultShowDoctorInterface:ShowDoctorInterface = {
  showSuccessMsg: false, setShowSuccessMsg: () => {},
  showAddModal: false, setShowAddModal: () => {},
  showEditModal: false, setShowEditModal: () => {},
  showDeleteModal: false, setShowDeleteModal: () => {},
  showDisappearModal: false, setShowDisappearModal: () => {},
  selectedDoctor: DefaultDoctorInterface, setSelectedDoctor: () => {},
}

export const ShowDoctorContext = createContext<ShowDoctorInterface>(DefaultShowDoctorInterface)


export interface FormDoctorInterface {
  fullName: string, setFullName: (fullName: string) => void,
  yearOfBirth: string, setYearOfBirth: (yearOfBirth: string) => void,
  placeOfBirth: string, setPlaceOfBirth: (placeOfBirth: string) => void,
  sex: string, setSex: (sex: string) => void,
  telephone: string, setTelephone: (telephone: string) => void,
  whatsapp: string, setWhatsapp: (whatsapp: string) => void,
  email: string, setEmail: (email: string) => void,
  current: string, setCurrent: (current: string) => void,
  origin: string, setOrigin: (origin: string) => void,
  medecinType: string, setMedecinType: (medecinType: string) => void,
  inscriptionDate: string, setInscriptionDate: (inscriptionDate: string) => void,
  avatar: File | any, setAvatar: (avatar: File | any) => void,
  password: string, setPassword: (password: string) => void,
  speciality: string, setSpeciality: (speciality: string) => void,
  cabinet: any, setCabinet: (cabinet: any) => void,
}

export const DefaultFormDoctorInterface: FormDoctorInterface = {
  fullName: "", setFullName: () => {},
  yearOfBirth: "", setYearOfBirth: () => {},
  placeOfBirth: "", setPlaceOfBirth: () => {},
  sex: "", setSex: () => {},
  telephone: "", setTelephone: () => {},
  whatsapp: "", setWhatsapp: () => {},
  email: "", setEmail: () => {},
  current: "", setCurrent: () => {},
  origin: "", setOrigin: () => {},
  medecinType: "", setMedecinType: () => {},
  inscriptionDate: "", setInscriptionDate: () => {},
  avatar: null, setAvatar: () => {},
  password: "", setPassword: () => {},
  speciality: "", setSpeciality: () => {},
  cabinet: null, setCabinet: () => {},
}

export const FormDoctorContext = createContext<FormDoctorInterface>(DefaultFormDoctorInterface)

